import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return <footer className="app-footer"><span>Copyright © 2025 Insecta</span><span> · </span><Link to="/termos-de-uso">Termos de uso e responsabilidade</Link></footer>;
};

export default Footer;
